import React from "react";
import { useTranslation } from "react-i18next";

import Table from "../../../tables/components/Table";

import useProductionsColumns from "../ProductionsView/hooks/useProductionsColumns";

import useProductionsVisibleColumns from "./hooks/useProductionsVisibleColumns";

export default function ProductionsTableView({ organization, data }) {
	const { t } = useTranslation();

	const columns = useProductionsColumns({ organization });
	const [visibleColumns, setVisibleColumns, defaultVisibleColumns] = useProductionsVisibleColumns({ organization });

	return (
		<Table
			data={data}
			columns={columns}
			visibleColumns={visibleColumns}
			defaultVisibleColumns={defaultVisibleColumns}
			enableColumnSelector
			onChangeVisibleColumns={setVisibleColumns}
			getDropdownMenuOptions={({ id }) => [
				{
					text: t("toProduction", "To production"),
					linkTo: `/production/${id}`,
				},
			]}
		/>
	);
}
